import React from 'react';
import { Box } from '@dropbox/dig-foundations';
import { Text } from '@dropbox/dig-components/typography';
import { UIIcon } from '@dropbox/dig-icons';
import { CheckmarkLine, CloseLine } from '@dropbox/dig-icons/assets';
import styles from './index.scss';
import type { BillingPlan } from '../types';
import type { FeatureRow } from './helpers';

interface FeatureValueProps {
  row: FeatureRow;
  plan: BillingPlan;
}

const FeatureValue: React.FC<FeatureValueProps> = ({ row, plan }) => {
  if (row.kind === 'check') {
    const included = row.isIncluded(plan);
    return included ? (
      <Box color="Primary Base" aria-label="Included">
        <UIIcon src={CheckmarkLine} size="medium" />
      </Box>
    ) : (
      <Box color="Text Subtle" aria-label="Not included">
        <UIIcon src={CloseLine} size="medium" />
      </Box>
    );
  }

  const value = row.getDisplayValue(plan);
  return (
    <Text
      variant="paragraph"
      size="small"
      tagName="span"
      isBold={row.kind === 'main'}
      className={styles.featureValueText}
    >
      {value}
    </Text>
  );
};

export default FeatureValue;
